
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Onedaytournearamravati() {



  const cardData =
  {
    keyword: ' One Day Tour Near Amravati',
    heading:  'Woodland Escape: One Day Tour Near Amravati',
    headingDescription: 'Woodland Escape Resort, an ideal destination for a one day tour near Amravati, offers the perfect combination of nature, adventure, and relaxation just a short drive from the city. Set amidst lush greenery, scenic lawns, and peaceful forest surroundings, the resort provides a refreshing escape for families, friends, and corporate groups alike. Guests can enjoy a variety of engaging activities such as ziplining, trekking, archery, cycling, swimming, and outdoor games, or simply unwind in cozy picnic areas and serene nature spots. With delicious food, comfortable amenities, and warm hospitality, Woodland Escape Resort near Amravati ensures your one-day tour is filled with fun, relaxation, and unforgettable experiences amidst nature’s beauty.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
{
"name": "One Day Tour Near Amravati",
"description": "Enjoy a refreshing one-day tour near Amravati with scenic spots, relaxing nature walks, and convenient day-trip itineraries perfect for a quick escape from the city."
},
{
"name": "Amravati Day Trip",
"description": "Plan a full day excursion in and around Amravati, including sightseeing, local attractions, and leisure activities suitable for families, friends, and solo travelers."
},
{
"name": "Amravati Sightseeing Tour",
"description": "Discover Amravati’s most popular sights, landmarks, and cultural spots on a guided sightseeing tour that balances exploration with relaxation."
},
{
"name": "Amravati Short Trip",
"description": "Perfect for a short getaway, this trip includes visits to natural, cultural, and historical locations near Amravati with minimal travel time."
},
{
"name": "Affordable One Day Tour Amravati",
"description": "Experience a budget-friendly one-day tour near Amravati, offering value for money with organized travel, meals, and activities in beautiful surroundings."
},
{
"name": "Amravati Local Attractions Tour",
"description": "Explore the hidden gems and popular attractions of Amravati city and its outskirts, including parks, gardens, riverside spots, and cultural landmarks."
},
{
"name": "Amravati Weekend Day Trip",
"description": "Plan a perfect weekend day trip from Amravati, combining sightseeing, nature exploration, and relaxation for a rejuvenating escape."
},
{
"name": "Amravati Family Day Trip",
"description": "Enjoy a family-friendly day trip in Amravati with kid-friendly activities, picnic areas, and scenic spots suitable for all ages."
},
{
"name": "Amravati Nature Day Tour",
"description": "Immerse yourself in Amravati’s natural beauty with a day tour covering hills, rivers, parks, and tranquil spots for relaxation and photography."
},
{
"name": "Amravati City Day Tour",
"description": "Discover the city attractions of Amravati, including historical landmarks, cultural sites, and local markets, with time for relaxation and refreshments."
},
{
"name": "Amravati Riverside Day Tour",
"description": "Spend a day along Amravati’s scenic riversides with leisure activities, picnic options, and opportunities for nature photography and calm relaxation."
},
{
"name": "Amravati Hill Day Trip",
"description": "Enjoy a hilltop day trip near Amravati, with panoramic views, trekking opportunities, and peaceful surroundings ideal for a short nature escape."
},
{
"name": "Amravati Day Excursion Packages",
"description": "Book full-day excursion packages in Amravati including transportation, guided tours, meals, and activities for a stress-free outing."
},
{
"name": "Amravati Tour Booking",
"description": "Reserve your one-day tour in Amravati in advance to secure your itinerary, ensuring a smooth and enjoyable experience with all arrangements taken care of."
},
{
"name": "Amravati One Day Outing",
"description": "Plan a delightful one-day outing from Amravati to nearby attractions, combining sightseeing, outdoor fun, and relaxation for a memorable day."
}
],
"tableData": [
["- One Day Tour Near Amravati", "- Amravati Day Trip"],
["- Amravati Sightseeing Tour", "- Amravati Short Trip"],
["- Affordable One Day Tour Amravati", "- Amravati Local Attractions Tour"],
["- Amravati Weekend Day Trip", "- Amravati Family Day Trip"],
["- Amravati Nature Day Tour", "- Amravati City Day Tour"],
["- Amravati Riverside Day Tour", "- Amravati Hill Day Trip"],
["- Amravati Day Excursion Packages", "- Amravati Tour Booking"],
["- Amravati One Day Outing", ""]
],
  


whychoose: [
  {
    "WhyChooseheading": "Perfect One Day Tour Near Amravati",
    "WhyChoosedescription": "Woodland Escape Resort is an ideal choice for a refreshing one-day tour near Amravati. Surrounded by dense forest, the resort offers a perfect escape to enjoy nature, adventure, and relaxation all in a single day."
  },
  {
    "WhyChooseheading": "Scenic Forest Location",
    "WhyChoosedescription": "Located just outside Amravati, Woodland Escape Resort is nestled amidst lush trees, tranquil surroundings, and fresh air. The forest setting provides a peaceful atmosphere, perfect for a rejuvenating day trip."
  },
  {
    "WhyChooseheading": "Day-Use Comfort and Amenities",
    "WhyChoosedescription": "Even for a one-day visit, the resort ensures comfort with shaded picnic areas, forest-view sit-outs, and relaxing resting spots. Guests can enjoy their day without compromising on convenience and comfort."
  },
  {
    "WhyChooseheading": "Activities for a Memorable Day",
    "WhyChoosedescription": "From nature walks and light trekking to pond-side relaxation and forest trails, Woodland Escape Resort offers activities suited for all ages. Guests can create lasting memories while exploring the beautiful surroundings."
  },
  {
    "WhyChooseheading": "Ideal for Family, Friends, and Groups",
    "WhyChoosedescription": "Whether it’s a family outing, a school trip, or a small group gathering, the resort’s spacious grounds and safe environment make it perfect for bonding, fun, and shared experiences."
  },
  {
    "WhyChooseheading": "Delicious Meals and Refreshments",
    "WhyChoosedescription": "The resort provides freshly prepared meals and snacks sourced locally, keeping you energized throughout your day trip. Enjoy picnic-style food or seated meals while surrounded by nature."
  },
  {
    "WhyChooseheading": "Easily Accessible from Amravati",
    "WhyChoosedescription": "Situated just a short drive from Amravati, Woodland Escape Resort is convenient for a day tour. Its accessible location allows you to spend maximum time enjoying the forest and activities rather than traveling."
  }
]













  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort for a one-day tour near Amravati?",
    answer: "Woodland Escape Resort offers a convenient and scenic setting close to Amravati, perfect for a refreshing one-day outing. Guests can enjoy nature, relaxation, and engaging activities all in a single day."
  },
  {
    question: "How far is Woodland Escape Resort from Amravati city?",
    answer: "The resort is located approximately 35–40 km from Amravati, which takes about 1 to 1.5 hours by car. It’s an ideal distance for a day trip without long travel times."
  },
  {
    question: "What activities can we do during the one-day tour?",
    answer: "Guests can enjoy nature walks, cycling, boating (if available), open-lawn games, and picnic-style relaxation. The resort balances fun and calm, ensuring a refreshing experience for everyone."
  },
  {
    question: "Is the one-day tour suitable for families and groups?",
    answer: "Yes! The resort is family-friendly with safe outdoor spaces for children, shaded seating for adults, and group-friendly arrangements, making it perfect for families, friends, or small groups."
  },
  {
    question: "Are meals included in the one-day tour package?",
    answer: "Yes, the package includes meals such as welcome drinks, a wholesome lunch, and tea/snacks in the evening, allowing guests to enjoy fresh local food without any hassle."
  },
  {
    question: "How can we book a one-day tour at Woodland Escape Resort?",
    answer: "Booking is simple — contact our reservations team via phone or WhatsApp, or visit our website to fill out the booking form. Advance booking is recommended, especially on weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Rahul & Family, Amravati",
    text: "We had a fantastic one-day tour at Woodland Escape Resort! The kids enjoyed the outdoor activities, the surroundings were peaceful, and the food was delicious. A perfect day trip from Amravati."
  },
  {
    name: "Miss. Neha & Friends, Amravati",
    text: "Our group visited Woodland Escape Resort for the day and loved every moment! The green surroundings, fun activities, and friendly staff made it an unforgettable experience. Highly recommended!"
  }
];












      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Day Tour Near Amravati",
  "image": "https://woodlandescape.com/assets/images/one-day-tour-near-amravati.jpg",
  "description": "Plan a memorable one day tour near Amravati at Woodlandescape Resort. Explore scenic landscapes, enjoy outdoor activities, and spend quality time with family and friends in a peaceful natural setting.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "632"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1199",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/one-day-tour-near-amravati"
  }
};



  return (
    <div>
<Helmet>
  <title>One Day Tour Near Amravati | Scenic Day Trip | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Enjoy a perfect one day tour near Amravati at Woodlandescape Resort. Explore nature, relax outdoors, and create memorable experiences for families, friends, and couples." 
  />
  <meta 
    name="keywords" 
    content="One Day Tour Near Amravati, Amravati Day Trip, Amravati Sightseeing Tour, Amravati Short Trip, Affordable One Day Tour Amravati, Amravati Local Attractions Tour, Amravati Weekend Day Trip, Amravati Family Day Trip, Amravati Nature Day Tour, Amravati City Day Tour, Amravati Riverside Day Tour, Amravati Hill Day Trip, Amravati Day Excursion Packages, Amravati Tour Booking, Amravati One Day Outing" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


  <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/60.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Onedaytournearamravati;